import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_19.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter20.json";
import Common_html from "./Common_html";

export default function Chapter_20() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

    const [membershipOpen, setMembershipOpen] = useState(false);
    const memberfunc = () => {
      setMembershipOpen(true);
    };

  return (
    <>
      <Head>
        <title>Divine Will, High Magick, Theurgy | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XIX"
        ></meta>
        <meta
          property="og:title"
          content="Divine Will, High Magick, Theurgy | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Copy_of_School_of_the_Divine_Infinite_Being_Chapter19_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration of the intersection between divine will, high magick, and theurgy, featuring mystical symbols and celestial elements."></meta>
        <meta
          property="og:description"
          content="In the Theurgy of our schools and within the order of Thelema the volutional will is a central doctrine."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=20"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Copy_of_School_of_the_Divine_Infinite_Being_Chapter19_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration of the intersection between divine will, high magick, and theurgy, featuring mystical symbols and celestial elements."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=20"></meta>
        <meta name="twitter:title" content="Divine Will, High Magick, Theurgy | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="In the Theurgy of our schools and within the order of Thelema the volutional will is a central doctrine."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=20" />
      </Head>


      <Common_html BlockData={BlockData} />
      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
